import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import {getResolvedFeedbackLink} from "../Parts/FeedbackLocationSelect";

export default class FeedbackZones extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Regions_Feedback._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.highlightRow = this.getHighlightPkeyFromLocation();
		this.rowRefs = {};
	}

	getHighlightPkeyFromLocation = () => {
		const search = (this.props.history && this.props.history.location && this.props.history.location.search)
			|| (typeof window !== 'undefined' ? window.location.search : '')
			|| '';
		const params = new URLSearchParams(search);
		const pkey = params.get('pkey');
		if (pkey == null || pkey === '') {
			return null;
		}
		const parsed = Number(pkey);
		return Number.isNaN(parsed) ? null : parsed;
	}

	/**
	 * Same pattern as AutomatedEmails: mutate state.filter, then fetchDataActual.
	 */
	fetchData = async (state) => {
		if (typeof this.state.filter === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}

		const highlightPkey = this.getHighlightPkeyFromLocation();
		if (highlightPkey) {
			this.state.filter.highlight_pkey = highlightPkey;
			this.state.highlightRow = highlightPkey;
		} else {
			delete this.state.filter.highlight_pkey;
			this.state.highlightRow = null;
		}

		this.model.filter = this.state.filter;
		this.setState({loading: true, highlightRow: highlightPkey});
		window.setTimeout(async () => {
			await this.fetchDataActual(state);
			this.scrollToHighlight();
		}, 100);
	}

	scrollToHighlight = () => {
		const pkey = this.state.highlightRow;
		if (!pkey) {
			return;
		}
		const row = this.rowRefs[pkey];
		if (row && typeof row.scrollIntoView === 'function') {
			row.scrollIntoView({behavior: 'smooth', block: 'center'});
		}
	}

	clearFilters = () => {
		if (this.props.history) {
			this.props.history.replace('/regions/feedback_list');
		}
		this.model.sort = 'ranking';
		this.model.order = 'asc';
		this.setState({
			key: Math.random(),
			filter: {},
			search: '',
			searchField: '',
			startDate: '',
			endDate: '',
			page: 0,
			limit: this.limit || 16,
			filterLocation: null,
			filterStatus: null,
			pages: 'Loading...',
			highlightRow: null,
		});
		localStorage.removeItem('table-preferences-' + this.tableStorageName);
	}

	render() {
		const {data, pages, limit, loading, highlightRow} = this.state;
		const columns =
			[
				{
					Header: "Ranking",
					accessor: "ranking",
					width: 100,
					Cell: (props) => {
						const pkey = props.original?.pkey;
						return (
							<div ref={(el) => {
								if (pkey) {
									this.rowRefs[pkey] = el;
								}
							}}>
								{props.value}
							</div>
						);
					}
				},
				{
					Header: "Internal Name",
					accessor: "name",
				},
				{
					Header: "Name to Customer",
					accessor: "pretty_name",
				},
				{
					Header: "Feedback Location",
					id: "feedback_location",
					accessor: (row) => {
						return row.feedback_locations?.description
							|| '';
					},
				},
				{
					Header: "Link",
					id: "link",
					Cell: props => {
						const raw = (getResolvedFeedbackLink(props.original) || '').trim();
						if (!raw) {
							return "N/A";
						}
						const href = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
						return (
							<a href={href} target="_blank" rel="noopener noreferrer">
								{raw}
							</a>
						);
					},
				},
				{
					Header: "Region",
					accessor: "regions.name",
				},
				{
					Header: "Viewed",
					id: "stat_viewed",
					accessor: obj => obj.stat_viewed || 0,
					width: 100,
				},
				{
					Header: "Clicked",
					id: "stat_clicked",
					accessor: obj => obj.stat_clicked || 0,
					width: 100,
				},
				{
					Header: "5 Stars",
					id: "stat_stars_5",
					accessor: obj => obj.stat_stars_5 || 0,
					width: 100,
				},
				{
					Header: "1-4 Stars",
					id: "stat_stars_1_4",
					width: 100,
					Cell: props => {
						const count = props.original.stat_stars_1_4 || 0;
						if (count > 0) {
							return (
								<Link to={`/admins/feedback_responses?feedback_zone=${props.original.pkey}`}>
									{count}
								</Link>
							);
						}
						return count;
					},
				},
				{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					Cell: props => {
						const regionId = props.original.region
							|| (props.original.regions && props.original.regions.pkey);
						return (
							<span>
								<Link to={`/regions/feedback?region=${regionId}&zone=${props.original.pkey}`}>
									<Button color="green-meadow" size={"sm"} block={true}>
										<Edit fontSize={'small'}/></Button>
								</Link>
							</span>
						);
					}
				},
			]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Feedback Zones')}
							{this.renderHeaderRight("Feedback Zones", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: 'ranking'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						getTrProps={(state, rowInfo) => {
							const pkey = rowInfo?.original?.pkey;
							const highlighted = pkey != null && Number(pkey) === Number(highlightRow);
							return {
								style: {
									background: highlighted ? '#ffcccc' : undefined,
								},
							};
						}}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
